import { routePaths } from 'components/Routes/data';
import RestrictedRoute from 'components/Routes/RestrictedRoute';
import React from 'react';
import { Redirect, Switch, useLocation } from 'react-router-dom';
import { KycInfo } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/KycInfo';
import { StatutoryInfo } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/StatutoryInfo';
import { PersonalDetails } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/PersonalDetails';
import { ReviewDetails } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/ReviewDetails';
import { Box, Modal, ModalBody, Spinner } from '@razorpay/blade/components';
import {
  SidebarContentWrapper,
  MultiStepFormWrapper,
  MainContentWrapper,
} from 'components/EmployeeOnboarding/components/styles';
import { OnboardingSidebar } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/components/OnboardingSidebar';
import { BankAccountDetails } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/BankAccountDetails';
import { FormProvider } from 'forms';
import { useSavedEmployeeData } from './hooks/useSavedEmployeeData';
import { useAdditionalDetailsStep } from './hooks/useAdditionalDetailsStep';
import { WizardInfoProvider } from 'components/WizardViews/providers/WizardInfoProvider';
import { routeToStepMap } from './constants';
import WizardPathToStepController from 'components/WizardViews/components/WizardPathToStepController';
import { Wizard, WizardStep } from 'forms/Wizard';
import { AdditionalDetails } from './AdditionalDetails';
import { ResetBladePortalOverridingStyles } from 'components/RunPayroll/ComplianceActions/styles';

export const EmployeeSelfOnboarding = () => {
  const location = useLocation();

  const { isLoadingQuery, selfOnboardingFormInitialData, shouldShowStatutoryDetailsStep } = useSavedEmployeeData();
  const { shouldShowAdditionalDetailsStep } = useAdditionalDetailsStep();

  if (location.pathname === routePaths.employeeOnboarding.employeeSelfOnboarding.root) {
    return <Redirect to={routePaths.employeeOnboarding.employeeSelfOnboarding.kycDetails} />;
  }

  if (isLoadingQuery) {
    return (
      <Box display="flex" height="80vh" alignItems="center" justifyContent="center">
        <Spinner accessibilityLabel="Loading" />
      </Box>
    );
  }

  return (
    <Box>
      {/* Legacy global table/typography CSS bleeds into Blade's DatePicker portal
          dialog (DOB on Personal Details, date custom fields on Additional
          Details). Mount the same reset RunPayroll's HRIS filter uses, once for
          the whole wizard. */}
      <ResetBladePortalOverridingStyles />
      <Modal isOpen={true} onDismiss={() => {}} size="full">
        <ModalBody padding="spacing.0">
          <FormProvider initialState={selfOnboardingFormInitialData}>
            <WizardInfoProvider beginStep={1} initialStep={1} totalSteps={6}>
              <MultiStepFormWrapper>
                <SidebarContentWrapper>
                  <OnboardingSidebar
                    shouldShowStatutoryDetailsStep={shouldShowStatutoryDetailsStep}
                    shouldShowAdditionalDetailsStep={shouldShowAdditionalDetailsStep}
                  />
                </SidebarContentWrapper>
                <MainContentWrapper>
                  <WizardPathToStepController routeStepMap={routeToStepMap} />
                  <Switch>
                    <Wizard>
                      <WizardStep step={1} component={KycInfo} />
                      <WizardStep step={2} component={BankAccountDetails} />
                      <WizardStep step={3} component={StatutoryInfo} />
                      <WizardStep step={4} component={PersonalDetails} />
                      <WizardStep step={5} component={AdditionalDetails} />
                      <WizardStep step={6} component={ReviewDetails} />
                    </Wizard>
                  </Switch>
                </MainContentWrapper>
              </MultiStepFormWrapper>
            </WizardInfoProvider>
          </FormProvider>
        </ModalBody>
      </Modal>
    </Box>
  );
};
